import React, { useEffect, useState } from 'react'

import Page1 from '../Price/Page1'
import Page2Kids from '../Price/Page2Kids'
import PageAccWoman from '../Price/PageAccWoman'
import { ReactComponent as Zaraön } from '../../../../../assets/Varlık2.svg'
import useOrderStore from 'store/client/orderStore'

import { ReactComponent as ZaraBom } from '../../../../../assets/DD.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg'
import { ReactComponent as AUDDOLAR } from '../../../../../assets/DDRED.svg'
import { ReactComponent as ZaraAcc } from '../../../../../assets/zaraaccess01.svg'
import { ReactComponent as ZaraAccLinge } from '../../../../../assets/linnngee.svg'
import { ReactComponent as ZaraAccEmty } from '../../../../../assets/accesemty.svg'
import { ReactComponent as ZaraAccLin } from '../../../../../assets/accesslin.svg'
import { ReactComponent as RedBorder } from '../../../../../assets/redborder.svg'
import { getArtworkSizes, artworkSizeCode, findArtworkSizeByCode } from 'lib/zaraArtworkSizes'




const L55XPRKNIFE = ({ data, selectColor, tab,bicakIziParams }, ref) => {
  const department = data.department
  const datt =data;
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [loading, setLoading] = useState(true);
  const [widthD, setWidthD] = useState(55)
  const [heightD, setHeightD] = useState(110)
  const [generalWidth, setGeneralWidth] = useState(30)
  const [generalHeight, setGeneralHeight] = useState(45)
 const [gridWidthx, setGridWidth] = useState(275)
 const [gridHeightx, setGridHeight] = useState(440)
  const [harmacn, setHarmacn] = useState(false) // harmacn state'i
  const [padleft, setPadleft] = useState(12)
  const [padright, setPadright] = useState(5)
  const [padtop, setPadtop] = useState(5)
  const [padbottom, setPadbottom] = useState(13)
  const { referance } = useOrderStore()

useEffect(() => {
  if(category === "Kids"){
    if(referance?.width === 95){
      setGeneralWidth(45)
      setGeneralHeight(30)
      setGridWidth(440.15)
      setGridHeight(285.12)
      setPadleft(5)
      setPadright(5)
      setPadtop(5)
      setPadbottom(5)
    } 
    setWidthD(55)
    setHeightD(95)
  } else if(subCategory === "ACC WOMAN"){
    setGeneralWidth(30)
    setGeneralHeight(45)
    setGridWidth(275)
    setGridHeight(440)
    setPadleft(12)
    setPadright(5)
    setPadtop(5)
    setPadbottom(13)
    setWidthD(55)
    setHeightD(80)
  }
}, [category, subCategory, referance?.width])


  function splitCurrency(value) {
    // Sayıyı string'e çevir
    const stringValue = value.toString()

    // Ondalık noktaya göre ayır
    let [integerPart, decimalPart] = stringValue.split('.')

    // Ondalık kısmı kontrol et ve düzenle
    if (!decimalPart) {
      // Ondalık kısım yoksa, 00 olarak ayarla
      decimalPart = '00'
    } else if (decimalPart.length === 1) {
      // Ondalık kısım tek haneliyse, sonuna bir 0 ekle
      decimalPart += '0'
    } else if (decimalPart.length > 2) {
      // Ondalık kısım iki haneden fazlaysa, ilk iki haneyi al
      decimalPart = decimalPart.substring(0, 2)
    }

    // Sonuçları döndür
    return [integerPart, decimalPart]
  }

  useEffect(() => {
    // South America kontrolü
    if (data.brandOrderNo && data.brandOrderNo.trim().endsWith('-25')) {
      setSouthAmerica(true);
    } else {
      setSouthAmerica(false);
    }
    // Harmacn kontrolü
    if (data.companyId === "6562742a5b252fdddcc588e7") {
      setHarmacn(true);
    } else {
      setHarmacn(false);
    }
  }, [data.brandOrderNo]);


  function getCurrencySymbol(type) {
    switch (type) {
      case 'AUD':
        return '$' // Avustralya Doları için dolar işareti
      case 'USD':
        return '$' // Avustralya Doları için dolar işareti
      case 'EUR':
        return '€' // Euro için euro işareti
      case 'BRL':
        return 'R$' // Brezilya Reali için Real işareti
      case 'GBP':
        return '£' // Brezilya Reali için Real işareti
      case 'CLP':
        return '$' // Brezilya Reali için Real işareti
      default:
        return '' // Diğer durumlar için boş string (veya belki başka bir varsayılan sembol)
    }
  }

  const [currentShape, setCurrentShape] = useState(null)
  const isBlack = referance?.backgroundColor === 'B'

  const [integerPart, decimalPart] = splitCurrency(data.priceLabel[0].mix[0].currency)
  const [integerPart2, decimalPart2] = splitCurrency(data.priceLabel[0].mix[1].currency)
  const currencySymbol = getCurrencySymbol(data.priceLabel[0].mix[0].type)
  const currencySymbol2 = getCurrencySymbol(data.priceLabel[0].mix[1].type)

  let integerPart3, decimalPart3, currencySymbol3, integerPart4, decimalPart4, currencySymbol4

  if (data.priceLabel[0].mix.length > 2) {
    ;[integerPart3, decimalPart3] = splitCurrency(data.priceLabel[0].mix[2].currency)
    currencySymbol3 = getCurrencySymbol(data.priceLabel[0].mix[2].type)
  } else {
    integerPart3 = decimalPart3 = currencySymbol3 = ''
  }

  if (data.priceLabel[0].mix.length > 3) {
    ;[integerPart4, decimalPart4] = splitCurrency(data.priceLabel[0].mix[3].currency)
    currencySymbol4 = getCurrencySymbol(data.priceLabel[0].mix[3].type)
  } else {
    integerPart4 = decimalPart4 = currencySymbol4 = ''
  }

  // NEW ZARA: newPriceLabel sizes; legacy: priceLabel amounts
  const artworkSizes = getArtworkSizes(data, selectColor)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      <div style={{ 
        width: `${generalWidth}cm`, 
        height: `${generalHeight}cm`, 
        position: 'relative', 
        backgroundColor: 'white',
        paddingLeft: `${padleft}mm`,
        paddingRight: `${padright}mm`,
        paddingTop: `${padtop}mm`,
        paddingBottom: `${padbottom}mm`,
        boxSizing: 'border-box',
        overflow: 'hidden'
      }}>
        {bicakIziParams ? (
          (() => {
            const allLabels = [];
            bicakIziParams.forEach((param) => {
              const matchedSizeData = findArtworkSizeByCode(artworkSizes, param.sizeCode);
              if (matchedSizeData) {

                const filteredIndo = artworkSizes;
                console.log("filteredIndo",filteredIndo);
                const matchedIndex = filteredIndo.findIndex(
                  (size) => findArtworkSizeByCode([size], param.sizeCode) != null
                );
                console.log("param",param);
                for (let i = 0; i < param.value; i++) {
                  allLabels.push({
                    type: param.type,
                    value: 1,
                    sizeData: matchedSizeData,
                    inx: matchedIndex !== -1 ? matchedIndex : 0
                  });
                }
              }
            });

            const gridWidth = gridWidthx;
            const gridHeight = gridHeightx;
            const labelWidth = widthD;
            const labelHeight = heightD;

            const columns = Math.floor(gridWidth / labelWidth);
            const rows = Math.floor(gridHeight / labelHeight);

            const maxLabels = columns * rows;
            const labelsToShow = allLabels.slice(0, maxLabels);

            return (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columns}, ${labelWidth}mm)`,
                  gridTemplateRows: `repeat(${rows}, ${labelHeight}mm)`,
                  width: `${gridWidth}mm`,
                  height: `${gridHeight}mm`,
                  gap: '0mm',
                  position: 'relative',
                  background: 'white'
                }}
              >
                {labelsToShow.map((item, index) => (

                  <div
                    key={index}
                    style={{
                      width: `${labelWidth}mm`,
                      height: `${labelHeight}mm`,
                      position: 'relative',
                      boxSizing: 'border-box',
                      border: '1px solid red',
                    }}
                  >
                    <div className='printable2' style={{ position: 'relative', zIndex: 20}}>
                      {category === 'Kids' ? (
                        <Page2Kids
                          key={index}
                          selectColor={selectColor}
                          barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(item.sizeData)}`}
                          data={data}
                          harmacn={harmacn}
                          sizeData={item.sizeData}
                          indo={data?.priceLabel[0]?.sizes}
                          szrgrp={data?.sizeGroup}
                          inx={item.inx}
                          integerpart3={integerPart3}
                          currencysymbol3={currencySymbol3}
                          SouthAmerica={SouthAmerica}
                          decimalpart3={decimalPart3}
                          decimalpart4={decimalPart4}
                          integerpart4={integerPart4}
                          currencysymbol4={currencySymbol4}
                          rifd={data.priceLabel[0].rifd}
                          bicakIzi={true}
                        />
                      ) : subCategory === 'ACC WOMAN' ? (
                        <PageAccWoman
                          key={index}
                          selectColor={selectColor}
                          barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(item.sizeData)}`}
                          data={data}
                          harmacn={harmacn}
                          sizeData={item.sizeData}
                          indo={data?.priceLabel[0]?.sizes}
                          szrgrp={data?.sizeGroup}
                          inx={item.inx}
                          integerpart3={integerPart3}
                          currencysymbol3={currencySymbol3}
                          decimalpart3={decimalPart3}
                          decimalpart4={decimalPart4}
                          integerpart4={integerPart4}
                          currencysymbol4={currencySymbol4}
                          rifd={data.priceLabel[0].rifd}
                          bicakIzi={true}
                        />
                      ) : (
                        <Page1
                          key={index}
                          selectColor={selectColor}
                          barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(item.sizeData)}`}
                          data={data}
                          harmacn={harmacn}
                          SouthAmerica={SouthAmerica}
                          sizeData={item.sizeData}
                          indo={data?.priceLabel[0]?.sizes}
                          szrgrp={data?.sizeGroup}
                          inx={item.inx}
                          integerpart3={integerPart3}
                          currencysymbol3={currencySymbol3}
                          decimalpart3={decimalPart3}
                          decimalpart4={decimalPart4}
                          integerpart4={integerPart4}
                          currencysymbol4={currencySymbol4}
                          rifd={data.priceLabel[0].rifd}
                          bicakIzi={true}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()
        ) : (
          // Normal veri için görünüm
          (() => {
            const filteredSizes = artworkSizes;
            const labelWidth = 55;
            const labelMargin = 0;
            
            const getLabelHeight = () => {
              if (category === 'Kids') return 95.2;
              if (subCategory === 'ACC WOMAN') return 80.2;
              return 110;
            };
            
            const labelHeight = getLabelHeight();
            const labelsPerRow = category !== 'Kids' && subCategory !== 'ACC WOMAN' ? 5 : 6;
            const pageWidth = 300 - 10;
            
            return filteredSizes.map((sizeData, index) => {
              const row = Math.floor(index / labelsPerRow);
              const col = index % labelsPerRow;
              
              const x = col * (labelWidth + labelMargin) + 5;
              const y = row * (labelHeight + labelMargin) + 13;
              
              return (
                <div 
                  key={index} 
                  style={{ 
                    position: 'absolute',
                    left: `${x}mm`,
                    top: `${y}mm`,
                    width: `${labelWidth}mm`,
                    height: `${labelHeight}mm`
                  }}
                >
                  {category === 'Kids' ? (
                    <div
                      style={{
                        width: `${labelWidth}mm`,
                        height: `${labelHeight}mm`,
                        border: '1px solid red',
                        position: 'absolute',
                        top: 0,
                        left: 0
                      }}
                    ></div>
                  ) : subCategory === 'ACC WOMAN' ? (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0
                      }}
                    >
                      {referance?.code === 'HPZCALL005' ? (
                        <ZaraAccEmty style={{ width: `${labelWidth}mm`, height: `${labelHeight}mm` }} />
                      ) : (
                        <ZaraAccLin style={{ width: `${labelWidth}mm`, height: `${labelHeight}mm` }} />
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: `${labelWidth}mm`,
                        height: `${labelHeight}mm`,
                        border: '1px solid red',
                        position: 'absolute',
                        top: 0,
                        left: 0
                      }}
                    ></div>
                  )}

                  <div className="printable" style={{ position: 'relative', marginLeft: -10 }}>
                    {category === 'Kids' ? (
                      <Page2Kids
                        key={index}
                        selectColor={selectColor}
                        barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(sizeData)}`}
                        data={data}
                        harmacn={harmacn}
                        sizeData={sizeData}
                        indo={data?.priceLabel[0]?.sizes}
                        szrgrp={data?.sizeGroup}
                        inx={index}
                        integerpart3={integerPart3}
                        currencysymbol3={currencySymbol3}
                        SouthAmerica={SouthAmerica}
                        decimalpart3={decimalPart3}
                        decimalpart4={decimalPart4}
                        integerpart4={integerPart4}
                        currencysymbol4={currencySymbol4}
                        rifd={data.priceLabel[0].rifd}
                      />
                    ) : subCategory === 'ACC WOMAN' ? (
                      <PageAccWoman
                        key={index}
                        selectColor={selectColor}
                        barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(sizeData)}`}
                        data={data}
                        harmacn={harmacn}
                        sizeData={sizeData}
                        indo={data?.priceLabel[0]?.sizes}
                        szrgrp={data?.sizeGroup}
                        inx={index}
                        integerpart3={integerPart3}
                        currencysymbol3={currencySymbol3}
                        decimalpart3={decimalPart3}
                        decimalpart4={decimalPart4}
                        integerpart4={integerPart4}
                        currencysymbol4={currencySymbol4}
                        rifd={data.priceLabel[0].rifd}
                      />
                    ) : (
                      <Page1
                        key={index}
                        selectColor={selectColor}
                        barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${artworkSizeCode(sizeData)}`}
                        data={data}
                        harmacn={harmacn}
                        SouthAmerica={SouthAmerica}
                        sizeData={sizeData}
                        indo={data?.priceLabel[0]?.sizes}
                        szrgrp={data?.sizeGroup}
                        inx={index}
                        integerpart3={integerPart3}
                        currencysymbol3={currencySymbol3}
                        decimalpart3={decimalPart3}
                        decimalpart4={decimalPart4}
                        integerpart4={integerPart4}
                        currencysymbol4={currencySymbol4}
                        rifd={data.priceLabel[0].rifd}
                      />
                    )}
                  </div>
                </div>
              );
            });
          })()
        )}
      </div>
    </div>
  )
}

export default React.forwardRef(L55XPRKNIFE)
